import { TabConfigType } from '@common';
import { VenueDetailsEndKey } from 'src/i18next';

type VenueTab = TabConfigType<
  'general' | 'shows' | 'holds' | 'overview' | 'rental' | 'files' | 'reports'
> & {
  labelKey: VenueDetailsEndKey<'TABS'>;
};

export const tabs: VenueTab[] = [
  {
    labelKey: 'GENERAL',
    value: 'general',
    requiredPermissions: [],
  },
  {
    labelKey: 'RENTAL',
    value: 'rental',
    requiredPermissions: [
      {
        permission: 'VENUES_RENTAL',
        action: 'READ',
      },
    ],
  },
  {
    labelKey: 'SHOWS',
    value: 'shows',
    requiredPermissions: [],
  },
  {
    labelKey: 'HOLDS',
    value: 'holds',
    requiredPermissions: [],
  },
  {
    labelKey: 'OVERVIEW',
    value: 'overview',
    requiredPermissions: [
      {
        permission: 'VENUES_OVERVIEW',
        action: 'READ',
      },
    ],
  },
  {
    labelKey: 'FILES',
    value: 'files',
    requiredPermissions: [],
  },
  {
    labelKey: 'REPORTS',
    value: 'reports',
    requiredPermissions: [
      {
        permission: 'REPORTS',
        action: 'READ',
      },
    ],
  },
];
